import z from "zod";
import { ViewIdSchema, ViewSchema } from "@storytell/types";

export const ViewIdParamsSchema = z.object({
  id: z.string(),
});

export const CreateViewInputSchema = ViewSchema.pick({
  name: true,
  description: true,
  filters: true,
});
export type CreateViewInput = z.infer<typeof CreateViewInputSchema>;

export const UpdateViewInputSchema = ViewSchema.pick({
  id: true,
  name: true,
  description: true,
  filters: true,
});
export type UpdateViewInput = z.infer<typeof UpdateViewInputSchema>;

// Sync endpoint returns a map of view IDs to view objects
export const ViewsSyncSchema = z.object({
  views: z.record(ViewIdSchema, ViewSchema),
});
export type ViewsSync = z.infer<typeof ViewsSyncSchema>;
